const PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';

export default PRICE_TICKET_REQUEST;
